import { formatRelativeTime } from "../lib/format";

export interface StaleBadgeProps {
  generatedAt: string;
}

export default function StaleBadge({ generatedAt }: StaleBadgeProps) {
  const age = formatRelativeTime(generatedAt);
  return (
    <span className="inline-flex shrink-0 items-center rounded-full bg-yellow-100 px-2 py-0.5 text-label-small text-yellow-800">
      Updated {age}
    </span>
  );
}
